const MAP = {
  draft: { label: "Draft", cls: "bg-[#E2E5EA] text-[#9CA3AF] border-[#C7CDD6]" },
  review: { label: "In Review", cls: "bg-blue-500/10 text-blue-400 border-blue-500/30" },
  approved: { label: "Approved", cls: "bg-red-500/10 text-red-500 border-red-500/30" },
  disbursed: { label: "Disbursed", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  active: { label: "Active", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  terminated: { label: "Terminated", cls: "bg-red-500/10 text-red-400 border-red-500/30" },
  "on-leave": { label: "On Leave", cls: "bg-red-500/10 text-red-500 border-red-500/30" },
};

export const StatusBadge = ({ status, testId }) => {
  const s = MAP[status] || { label: status, cls: "bg-[#E2E5EA] text-[#9CA3AF] border-[#C7CDD6]" };
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls}`}
    >
      {s.label}
    </span>
  );
};
